import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';

import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';

import { AlertService, AuthenticationService } from '../_services';
import { GeocodeService } from '../_services/geocode.service';
import { Globals } from '../_helpers';
import { HttpHeaders, HttpClient } from '@angular/common/http';


export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

@Component({
    selector: 'assessor-login',
    templateUrl: './login.component.html',
})

export class LoginComponent implements OnInit {

    @ViewChild('alertBrowser') private alertBrowser: SwalComponent;
    @ViewChild('LatLongSwal') private LatLongSwal: SwalComponent;

    public alertOption: SweetAlertOptions = {};

    usernameFormControl = new FormControl('', [
        Validators.required,
    ]);
    matcher = new MyErrorStateMatcher();

    loading = false;
    submitted = false;
    isErrorLogin = false;
    errorMsg: string;
    returnUrl: string;
    userinfo: any;
    studentid: number = 0;    
    examid: number = 0;  
    passcode:string = '';    
    latitude: number;
    longitude: number;
    address: string;
    errorMessage: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private GeocodeService: GeocodeService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService,
        private http: HttpClient

    ) { }


    ngOnInit() {
        /* clear loaclStorege */
        //localStorage.clear();
        //sessionStorage.clear();

        // reset login status
        //this.authenticationService.logout();
        localStorage.removeItem('currentUser');
        localStorage.removeItem('supspw_geoIPStu');
        localStorage.removeItem('supspw_geoIPStu_type');
        sessionStorage.removeItem("pkshn_exam_set");        
        sessionStorage.removeItem("pkshn_feedback_set");        
        sessionStorage.removeItem("pkshn_exam_time");        
        this.spinner.hide();
        if(this.globals.isExamOver == true)
        {
            this.spinner.show();
            window.location.reload();
            return;            
        }        
        var step = this.route.snapshot.paramMap.get("step");

        if(step == null || step == undefined)
        {
          //this.returnUrl = '/sectors';
        }
        else{
          this.passcode = atob(step);
          this.usernameFormControl.setValue(this.passcode);
        } 

        // get return url from route parameters or default to '/'
        //this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        this.userinfo = JSON.parse(localStorage.getItem('userinfo_ps')); //console.log(this.userinfo);
        if(this.userinfo == undefined)
        {
            this.studentid = 0;
        }
        else
        {
            this.studentid = this.userinfo['student_id'];
        }
        if(sessionStorage.getItem("pkshn_select_exam_ps") == undefined)
        {
            this.examid = 0;
        }
        else
        {
            this.examid =   parseInt(sessionStorage.getItem("pkshn_select_exam_ps"));
        }        
        this.returnUrl = '/';


        navigator.geolocation.getCurrentPosition(
          (position: { coords: { latitude: number; longitude: number } }) => {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            console.log(`Latitude: ${this.latitude}, Longitude: ${this.longitude}`);
          },
          (error: { message: string }) => {
            console.error("Error getting location:", error.message);
            this.LatLongSwal.show(); ;
            //alert('You have denied Geolocation. You must allow Geolocation to proceed to give an assessment.');
            this.router.navigateByUrl('/');
          }
        );

    }

/*    ngAfterViewInit() {
        this.detectBrowserSuport();
    }*/

    onSubmit() {
        this.submitted = true;

        /* stop here if form is invalid */
        if (this.usernameFormControl.value == '') {
            this.isErrorLogin = false;
            return false;
        }
        else {
            this.loading = true;
            this.spinner.show();
            if(this.examid == 0)
            {
                this.authenticationService.login(this.globals.root_url, this.usernameFormControl.value, this.studentid)
                    .pipe(first())
                    .subscribe(
                        data => {
                            //console.log(data);
                            if (data.code == 1000) {
                                  this.GeocodeService.getAddress(this.latitude, this.longitude)
                                    .subscribe((res: any) => {
                                      if (res.display_name) {
                                        //this.address = res.display_name;
                                        localStorage.setItem('supspw_geoIPStu_type', '1');
                                        localStorage.setItem('supspw_geoIPStu', JSON.stringify(res));
                                      } else if (res.results) {
                                        //this.address = res.results[0].formatted;
                                        localStorage.setItem('supspw_geoIPStu_type', '2');
                                        localStorage.setItem('supspw_geoIPStu', JSON.stringify(res));
                                      } else {
                                        //this.address = 'Unable to extract address.';
                                      }
                                    });
                                    //return;
/*                                    this.http.get("https://api.ip2location.io/?key=96617B7F301CAC5D0B0769DAEB2AE86E").subscribe((res: any) => {
                                //this.http.get("https://ipapi.co/json/").subscribe((res: any) => {
                                    //this.http.get("//ip-api.com/json").subscribe((res:any)=>{ // for local testing
                                    var geoipresponse = res;
                                    if (geoipresponse != undefined) {
                                        localStorage.setItem('supspw_geoIPStu', JSON.stringify(res));
                                    }
                                });*/
                                this.globals.isExamOver = false;
                                this.isErrorLogin = false;
                                var settings = data.settings; //console.log('settings', settings);
                                
                                localStorage.setItem('currentUser', JSON.stringify({ usercode: data.usercode, userid: data.user_id, subuserid: data.sub_user_id, name: data.name, code: this.usernameFormControl.value, id: data.std_id, examstatus: data.isvivaDone }));
                                if (settings) {
                                    sessionStorage.setItem('pkshn_exam_set', JSON.stringify(settings));
                                }
                                var practical_id = data.practical_id;

                                if(settings) 
                                {
                                    if (settings.entered_theory4 == 1 && settings.entered_theory3 == 0) {
                                        var parms = this.globals.getRandUrl('test-start');
                                        this.router.navigateByUrl('/test-start/'+parms);  
                                        return;  
                                    }
                                    else if (settings.typing_exam == 1 && data.enter_typing_exam === 1) {
                                        this.router.navigateByUrl('/typing-simulation/'+settings.exam_id);
                                        return;
                                    }
                                    else if ((data.isvivaDone == 1 || data.isvivaDone == 3) && settings.descriptive == 1 && data.descriptive == 0) {
                                        this.router.navigateByUrl('/descriptive');
                                        return;
                                    }
                                    else if(settings.auth_stage > 0)
                                    {
                                        switch(settings.auth_stage)
                                        {
                                           case 1: {
                                                var parms = this.globals.getRandUrl('verify');
                                                this.router.navigateByUrl('/verify/' + parms);  
                                                break;                                         
                                           } 
                                           case 2: {
                                                if (settings.camera == 1) {
                                                    var parms = this.globals.getRandUrl('upload-idpic');
                                                    this.router.navigateByUrl('/upload-idpic/' + parms);
                                                } 
                                                else {
                                                    var parms = this.globals.getRandUrl('test-start');
                                                    this.router.navigateByUrl('/test-start/' + parms);                                  
                                                }                                            
                                                break;                                         
                                           } 
                                           case 3: {
                                                var parms = this.globals.getRandUrl('upload-pic');
                                                this.router.navigateByUrl('/upload-pic/' + parms);
                                                break;                                         
                                           }  
                                           case 4: {
                                                if (settings.feedback_survey == 1) {
                                                   this.router.navigateByUrl('/start-feedback');                                
                                                } 
                                                else
                                                {
                                                    var parms = this.globals.getRandUrl('test-start');
                                                    this.router.navigateByUrl('/test-start/' + parms);
                                                }
                                                break;                                         
                                           }  
                                           case 5: {
                                                var parms = this.globals.getRandUrl('test-start');
                                                this.router.navigateByUrl('/test-start/' + parms);
                                                break;                                         
                                           }                                                                                                                                                        
                                        }
                                    }
                                    else if (settings.otp == 1) {
                                        //var parms = this.globals.getRandUrl('otp');
                                        var qstring = data.usercode + '//@spwd++sup@//' + data.user_id + '//@spwd++sup@//' + data.sub_user_id + '//@spwd++sup@//' + data.std_id;
                                        var parms = window.btoa(qstring);
                                        this.router.navigateByUrl('/otp/' + parms);
                                        //this.router.navigate(['otp'], { queryParams: { page: 1 } });
                                    }
                                    else {
                                        var parms = this.globals.getRandUrl('verify');
                                        this.router.navigateByUrl('/verify/' + parms);
                                        //this.router.navigate(['verify'], { queryParams: { page: 1 } });
                                    }                                    
                                }
                                else
                                {
                                    if (typeof practical_id != 'undefined') {
                                        let sett = { 'examid': data.exam_id, 'practicalid': data.practical_id };
                                        sessionStorage.setItem('pkshn_vc_set', JSON.stringify(sett));
                                        var qstring = data.usercode + '//@spwd++sup@//' + data.exam_id + '//@spwd++sup@//' + data.practical_id + '//@spwd++sup@//' + data.std_id;
                                        var parms = window.btoa(qstring);
                                        this.router.navigateByUrl('/practical-welcome/' + parms);
                                    }
                                }
                            }
                            else {
                                this.isErrorLogin = true;
                                this.errorMsg = data.status;
                                this.loading = false;
                            }
                            this.spinner.hide();
                        },
                        error => {
                            this.isErrorLogin = true;
                            this.errorMsg = 'Invalid Login code !!';
                            this.alertService.error(error);
                            this.loading = false;
                            this.spinner.hide();
                        }
                    );
            }
            else
            {
                this.authenticationService.loginmock(this.globals.root_url, this.usernameFormControl.value, this.studentid)
                    .pipe(first())
                    .subscribe(
                        data => {
                            if (data.code == 1000) {
                                this.http.get("https://ipapi.co/json/").subscribe((res: any) => {
                                    //this.http.get("//ip-api.com/json").subscribe((res:any)=>{ // for local testing
                                    var geoipresponse = res;
                                    if (geoipresponse != undefined) {
                                        localStorage.setItem('supspw_geoIPStu', JSON.stringify(res));
                                    }
                                });
                                this.globals.isExamOver = false;
                                this.isErrorLogin = false;
                                var settings = data.settings;
                                localStorage.setItem('currentUser', JSON.stringify({ usercode: data.usercode, userid: data.user_id, subuserid: data.sub_user_id, name: data.name, code: this.usernameFormControl.value, id: data.std_id, examstatus: data.isvivaDone }));
                                if (typeof settings != undefined || typeof settings != 'undefined') {
                                    sessionStorage.setItem('pkshn_exam_set', JSON.stringify(settings));
                                }
                                var practical_id = data.practical_id;

                                if ((data.isvivaDone == 1 || data.isvivaDone == 3) && settings.descriptive == 1 && data.descriptive == 0) {
                                    this.router.navigateByUrl('/descriptive');

                                }else  if (typeof practical_id != 'undefined') {
                                    let sett = { 'examid': data.exam_id, 'practicalid': data.practical_id };
                                    sessionStorage.setItem('pkshn_vc_set', JSON.stringify(sett));
                                    var qstring = data.usercode + '//@spwd++sup@//' + data.exam_id + '//@spwd++sup@//' + data.practical_id + '//@spwd++sup@//' + data.std_id;
                                    var parms = window.btoa(qstring);
                                    this.router.navigateByUrl('/practical-welcome/' + parms);
                                }
                                else if (settings.otp == 1) {
                                    //var parms = this.globals.getRandUrl('otp');
                                    var qstring = data.usercode + '//@spwd++sup@//' + data.user_id + '//@spwd++sup@//' + data.sub_user_id + '//@spwd++sup@//' + data.std_id;
                                    var parms = window.btoa(qstring);
                                    this.router.navigateByUrl('/otp/' + parms);
                                    //this.router.navigate(['otp'], { queryParams: { page: 1 } });
                                }
                                else {
                                    var parms = this.globals.getRandUrl('verify');
                                    this.router.navigateByUrl('/verify/' + parms);
                                    //this.router.navigate(['verify'], { queryParams: { page: 1 } });
                                }
                            }
                            else {
                                this.isErrorLogin = true;
                                this.errorMsg = data.status;
                                this.loading = false;
                            }
                            this.spinner.hide();
                        },
                        error => {
                            this.isErrorLogin = true;
                            this.errorMsg = 'Invalid Login code !!';
                            this.alertService.error(error);
                            this.loading = false;
                            this.spinner.hide();
                        }
                    );                
            }
        }
    }


    private detectBrowserSuport() {
        let isSupport = true;
        let video = document.createElement('video');
        if (video.canPlayType('video/ogg; codecs="theora"') == "")
            isSupport = false;

        if (video.canPlayType('video/mp4; codecs="avc1.42E01E"') == "")
            isSupport = false;

        if (video.canPlayType('video/webm; codecs="vp8, vorbis"') == "")
            isSupport = false;

        if (video.canPlayType('video/webm; codecs="vp9"') == "")
            isSupport = false;

        const audio = document.createElement('audio');
        if (audio.canPlayType('audio/mpeg') == "")
            isSupport = false;

        if (audio.canPlayType('audio/wav') == "")
            isSupport = false;

        if (!isSupport) {
            this.alertBrowser.show();
            //alert('Your brawser is unsupported, please update your brawser.');
        }
        else {
            console.log('ok');
        }

    }
    onHome() {
        this.router.navigate(['/home'])
    }
    onDashboard() {
        this.router.navigate(['/dashboard'])
    }    
}


